<template>
  <div class="case-base-page col-block width-full">
    <template v-if="layoutBlocks.includes('form')">
      <div class="form-container col-block width-full">
        <div v-if="(['create'].includes(mode) && ['supervisor', 'manager'].includes(user.role)) || (['edit'].includes(mode) && ['supervisor'].includes(user.role))" class="form-block col-block width-full">
          <customForm
            :init="caseData"
            :layoutType="'grid'"
            :groupCount="formGroupCount"
            :alerts="alerts"
            :forms="formOptions['field0']"
            :scope="scope"
            :reading="false"
            @change="(result, validate, errors) => formOnChange('case', 'field0', result, validate, errors)"
          >
            <template slot="USER_ID" slot-scope="props">
              <div :name="props" class="input-group" :style="{ width: '100%', padding: 0 }">
                <inputTag
                  :style="{ width: '100%' }"
                  :inputStyle="{ 'padding-right': '40px' }"
                  :init="(userOptions.find(option => option.value === result['case'].user_id) || {}).title"
                  :emptyDisplay="true"
                  :disabled="false"
                  :placeholder="''"
                  :tags="users"
                  :prefix="'(?:^)'"
                  :target="'^(.*?)$'"
                  :replace="user => [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')"
                  :filter="content => user => content && ([user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')).match(new RegExp(content.replace(/(\(|\)|\[|\]|\{|\}|\\)/g, '\\$1'), 'i'))"
                  :tagDisplay="user => [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')"
                  @input="content => onEvent('input', content)"
                  @send="content => onEvent('send', content)"
                  @tag="content => onEvent('tag', content)"
                ></inputTag>
              </div>
            </template>
          </customForm>
        </div>
        <div class="form-block col-block width-full">
          <customForm
            :init="caseData"
            :layoutType="'grid'"
            :groupCount="formGroupCount"
            :alerts="alerts"
            :forms="formOptions['field1']"
            :scope="scope"
            :reading="false"
            @change="(result, validate, errors) => formOnChange('case', 'field1', result, validate, errors)"
          >
            <template slot="AFFECTED" slot-scope="props">
              <div v-if="props.form.type === 'custom'" class="AFFECTED-block row-block flex-start" :name="props">
                <div class="AFFECTED-title">{{ $t('COMPONENT.case.base.customForm.affected.___title') }}</div>
                <switchButton
                  :disabled="false"
                  :checked="caseData.affected"
                  @input="c => { result['case'].affected = c }"
                ></switchButton>
                <div :style="{ flex: 1 }"></div>
              </div>
            </template>
          </customForm>
        </div>
      </div>
    </template>
    <template v-if="layoutBlocks.includes('analysis')">
      <hr class="custom full" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <div class="analysis-container col-block width-full">
        <div class="analysis-block col-block width-full">
          <customForm
            :init="analysisData"
            :layoutType="'grid'"
            :groupCount="6"
            :alerts="alerts"
            :forms="formOptions['field2']"
            :scope="'test'"
            :reading="false"
            @change="(result, validate, errors) => formOnChange('analysis', 'field2', result, validate, errors)"
          >
            <template slot="REPORT_PHENOVARDB" slot-scope="props">
              <div class="REPORT_PHENOVARDB-block row-block flex-start" :name="props">
                <div class="REPORT_PHENOVARDB-title">{{ $t('COMPONENT.case.base.customForm.reportPhenovardb.___off') }}</div>
                <switchButton
                  :disabled="!reportDatabaseable"
                  :checked="analysisData.report_phenovardb"
                  :customStyle="{ cursor: 'pointer' }"
                  @click="e => !reportDatabaseable && addToast('error', $t('COMMON.toast.___atLeastOneCardOpen'))"
                  @input="c => { result['analysis'].report_phenovardb = c }"
                ></switchButton>
                <div class="REPORT_PHENOVARDB-title active">{{ $t('COMPONENT.case.base.customForm.reportPhenovardb.___on') }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </template>
          </customForm>
          <slot v-if="isUpdate" :name="'analysis-update'" :data="sendData"></slot>
        </div>
        <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
        <div class="analysis-block col-block width-full">
          <slot :name="'analysis-import'" :data="sendData"></slot>
          <div v-if="!_LOCAL_BUILD && (locale === 'ja')" class="intractable-disease-container col-block width-full">
            <intractableDisease
              :defaultDatas="intractableDiseaseResult"
              @change="result => intractableDiseaseResult = result"
            ></intractableDisease>
          </div>
          <div class="analysis-title-container row-block">
            <div class="analysis-title main">{{ $t('COMPONENT.case.base.analysis.___title') }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="phenotype-panel-container block col-block">
            <div class="block-content">
              <div class="display-icon center-block" :class="{ active: display.phenotypePanel }" @click="e => display.phenotypePanel = !display.phenotypePanel">
                <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
              </div>
              <div class="block-title-container row-block">
                <div class="block-title">{{ $t('COMPONENT.case.base.analysis.panel.___title') }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-show="display.phenotypePanel" class="phenotype-panel-block block-content col-block width-full">
                <template v-if="phenotypePanels.length">
                  <div class="panel-group col-block flex-start" v-for="(panel, pindex) in phenotypePanels" :key="pindex">
                    <div
                      class="item-container row-block"
                      @click="e => {
                        selectedPhenotypes['panelPhenotypes'] =
                          selectedPhenotypes['panelPhenotypes'].some(phenotype => phenotype.panel.id === panel.id) ? selectedPhenotypes['panelPhenotypes'].filter(p => p.panel.id !== panel.id)
                          : selectedPhenotypes['panelPhenotypes'].filter(p => p.panel.id !== panel.id).concat(panel.phenotypes)
                      }"
                    >
                      <img
                        class="checkbox"
                        :src="
                          selectedPhenotypes['panelPhenotypes'].filter(phenotype => phenotype.panel.id === panel.id).length === panel.phenotypes.length ? require('../../assets/images/checkbox-true.svg')
                          : selectedPhenotypes['panelPhenotypes'].some(phenotype => phenotype.panel.id === panel.id) ? require('../../assets/images/checkbox-minus.svg')
                          : require('../../assets/images/checkbox-false.svg')
                        "
                      >
                      <div class="item-title main">{{ panel.panel }}</div>
                    </div>
                    <div class="panel-item-container row-block flex-wrap">
                      <div
                        class="item-container row-block"
                        v-for="(phenotype, phindex) in panel.phenotypes"
                        :key="phindex"
                        @click="e => {
                          selectedPhenotypes['panelPhenotypes'] =
                            selectedPhenotypes['panelPhenotypes'].includes(phenotype) ? selectedPhenotypes['panelPhenotypes'].filter(p => (p.panel.id + '_' + p.id) !== (phenotype.panel.id + '_' + phenotype.id))
                            : selectedPhenotypes['panelPhenotypes'].concat([phenotype])
                        }"
                      >
                        <img
                          class="checkbox"
                          :src="
                            selectedPhenotypes['panelPhenotypes'].includes(phenotype) ? require('../../assets/images/checkbox-true.svg')
                            : require('../../assets/images/checkbox-false.svg')
                          "
                        >
                        <div class="item-title">{{ phenotype.query }}</div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="row-block" :style="{ width: '100%' }">
                    <router-link class="link dark" :to="{ name: 'panel' }">{{ $t('COMPONENT.case.base.analysis.panel.___empty') }}</router-link>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="search-container row-block">
            <div class="search-block col-block" :style="{ flex: 1 }">
              <div class="row-block" :style="{ width: '100%' }">
                <div class="search-input input-group" :style="{ flex: 1 }">
                  <phenotypeTag
                    :style="{ width: '100%' }"
                    :placeholder="$t('COMPONENT.case.base.analysis.phenotype.phenotypeTag.___placeholder')"
                    :init="tagData.query['phenotype']"
                    :dataInfo="tagData.tag['phenotypes'].info"
                    :phenotypes="tagData.tag['phenotypes'].datas"
                    @input="content => { tagData.query['phenotype'] = content; getPhenotypes(content); customValidate([], ['selected', 'genePanel']) }"
                    @tag="content => { tagData.query['phenotype'] = content; customValidate([], ['selected', 'genePanel']) }"
                    @send="content => (tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'] ? addToSearch('phenotype', tagData.query['phenotype']) : ''"
                  ></phenotypeTag>
                  <img :src="require('../../assets/images/search-solid.svg')" alt="">
                </div>
                <div :style="{ width: '22px' }"></div>
                <button class="main-button circle-button" :disabled="!((tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'])" @click="e => (tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'] ? addToSearch('phenotype', tagData.query['phenotype']) : ''">
                  <span>{{ $t('COMMON.button.___add') }}</span>
                </button>
              </div>
              <div v-if="searchedPhenotypes['phenotypes'].length" class="selected-container col-block flex-start">
                <div class="selected-title-container row-block">
                  <div class="selected-title">{{ $t('COMPONENT.case.base.analysis.phenotype.___selectedTitle') }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="selected-item-container row-block flex-wrap">
                  <div
                    class="item-container row-block"
                    v-for="(phenotype, phindex) in searchedPhenotypes['phenotypes']"
                    :key="phindex"
                    :class="{
                      disabled: selectedLimit['phenotypes'] && !selectedPhenotypes['phenotypes'].includes(phenotype)
                    }"
                    @click="e => {
                      selectedPhenotypes['phenotypes'] =
                        e.currentTarget.className.split(' ').includes('disabled') ? selectedPhenotypes['phenotypes']
                        : selectedPhenotypes['phenotypes'].includes(phenotype) ? selectedPhenotypes['phenotypes'].filter(p => p.id !== phenotype.id)
                        : selectedPhenotypes['phenotypes'].concat([phenotype])
                    }"
                  >
                    <div class="item-block row-block shrink">
                      <img
                        class="checkbox"
                        :src="
                          selectedPhenotypes['phenotypes'].includes(phenotype) ? require('../../assets/images/checkbox-true.svg')
                          : require('../../assets/images/checkbox-false.svg')
                        "
                      >
                      <div class="item-title shrink break-line">{{ phenotype.query }}</div>
                    </div>
                    <img class="option" :src="require('../../assets/images/add-to-panel-icon.svg')" alt="" @click="e => addToPanel(phenotype)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '0px' }">
          <div class="analysis-title-container row-block">
            <div class="analysis-title">{{ $t('COMPONENT.case.base.analysis.gene.___title') }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="gene-panel-container block col-block">
            <div class="block-content">
              <div class="display-icon center-block" :class="{ active: display.genePanel }" @click="e => display.genePanel = !display.genePanel">
                <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
              </div>
              <div class="block-title-container row-block">
                <div class="block-title">{{ $t('COMPONENT.case.base.analysis.genePanel.___title') }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-if="(userGenePanelDatas || []).length" v-show="display.genePanel" class="gene-panel-block block-content col-block width-full">
                <div class="selected-item-container row-block flex-wrap">
                  <div
                    class="item-container row-block"
                    v-for="(gene, gindex) in userGenePanelDatas"
                    :key="gindex"
                    :class="{
                      disabled: selectedLimit['genes'] && !selectedPhenotypes['panelGenes'].includes(gene)
                    }"
                    @click="e => {
                      selectedPhenotypes['panelGenes'] =
                        e.currentTarget.className.split(' ').includes('disabled') ? selectedPhenotypes['panelGenes']
                        : selectedPhenotypes['panelGenes'].includes(gene) ? selectedPhenotypes['panelGenes'].filter(g => g.name + '_' + g.id !== gene.name + '_' + gene.id)
                        : selectedPhenotypes['panelGenes'].concat([gene])
                    }"
                  >
                    <div class="item-block row-block shrink">
                      <img
                        class="checkbox"
                        :src="
                          selectedPhenotypes['panelGenes'].includes(gene) ? require('../../assets/images/checkbox-true.svg')
                          : require('../../assets/images/checkbox-false.svg')
                        "
                      >
                      <div class="item-title shrink break-line">{{ ((gene.category[0].toUpperCase() + gene.category.slice(1)) + ': ').replace('Gene: ', '') + gene.name }}</div>
                    </div>
                    <img class="option" :src="require('../../assets/images/gene-panel-white-icon.svg')" alt="" @click.stop="e => openGenePanelDataSelect(gene)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="search-container row-block">
            <div class="search-block col-block" :style="{ flex: 1 }">
              <div class="row-block flex-start" :style="{ width: '100%' }">
                <div class="search-input input-group" :style="{ flex: 1 }">
                  <geneTag
                    :style="{ width: '100%' }"
                    :tagHeight="'300px'"
                    :placeholder=" $t('COMPONENT.case.base.analysis.gene.geneTag.___placeholder')"
                    :init="tagData.query['gene']"
                    :dataInfo="tagData.tag['genes'].info"
                    :genes="tagData.tag['genes'].datas"
                    @input="content => { tagData.query['gene'] = content; getGenes(content); customValidate([], ['selected', 'genePanel']) }"
                    @tag="content => { tagData.query['gene'] = content.name; tagData.curTag['gene'] = content; customValidate([], ['selected', 'genePanel']) }"
                    @send="content => (tagData.tag['genes'].datas || []).length && tagData.query['gene'] ? addToSearch('gene', tagData.curTag['gene'] || tagData.query['gene']) : ''"
                  ></geneTag>
                  <img :src="require('../../assets/images/search-solid.svg')" alt="">
                </div>
                <div :style="{ width: '22px' }"></div>
                <button class="main-button circle-button" :class="{ loading: loading['addToSearch'] }" :disabled="!((tagData.tag['genes'].datas || []).length && tagData.query['gene'])" @click="e => (tagData.tag['genes'].datas || []).length && tagData.query['gene'] ? addToSearch('gene', tagData.curTag['gene'] || tagData.query['gene']) : ''">
                  <span>{{ $t('COMMON.button.___add') }}</span>
                </button>
                <div :style="{ width: '6px' }"></div>
                <div class="icon-block" :style="{ '--size': '40px' }" @click.stop="e => openGenePanelSearch()">
                  <img :src="require('../../assets/images/gene-panel-icon.svg')" alt="">
                </div>
              </div>
              <div v-if="searchedPhenotypes['genes'].length" class="selected-container col-block flex-start">
                <div class="selected-title-container row-block">
                  <div class="selected-title">{{ $t('COMPONENT.case.base.analysis.gene.___selectedTitle') }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="selected-item-container row-block flex-wrap">
                  <div
                    class="item-container row-block"
                    v-for="(gene, gindex) in searchedPhenotypes['genes']"
                    :key="gindex"
                    :class="{
                      disabled: selectedLimit['genes'] && !selectedPhenotypes['genes'].includes(gene)
                    }"
                    @click="e => {
                      selectedPhenotypes['genes'] =
                        e.currentTarget.className.split(' ').includes('disabled') ? selectedPhenotypes['genes']
                        : selectedPhenotypes['genes'].includes(gene) ? selectedPhenotypes['genes'].filter(g => g.name + '_' + g.id !== gene.name + '_' + gene.id)
                        : selectedPhenotypes['genes'].concat([gene])
                    }"
                  >
                    <div class="item-block row-block shrink">
                      <img
                        class="checkbox"
                        :src="
                          selectedPhenotypes['genes'].includes(gene) ? require('../../assets/images/checkbox-true.svg')
                          : require('../../assets/images/checkbox-false.svg')
                        "
                      >
                      <div class="item-title shrink break-line">{{ gene.name }}</div>
                    </div>
                    <img class="option" :src="require('../../assets/images/gene-panel-white-icon.svg')" alt="" @click.stop="e => openGenePanelDataSelect(gene)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="allele-frequency-threshold-container block col-block">
            <div class="block-content">
              <div class="display-icon center-block" :class="{ active: display.alleleFrequencyThreshold }" @click="e => display.alleleFrequencyThreshold = !display.alleleFrequencyThreshold">
                <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
              </div>
              <div class="block-title-container row-block">
                <div class="block-title">{{ $t('COMPONENT.case.base.analysis.alleleFrequencyThreshold.___title') }}</div>
                <borCor
                  :width="'300px'"
                  :background="'white'"
                  :border="'#CCCCCC'"
                  :radius="'0px'"
                  :blockStyle="{ padding: '10px' }"
                >
                  <div slot="trigger">
                    <img :src="require('../../assets/images/info-circle-regular.svg')" alt="" :style="{ width: '16px' }">
                  </div>
                  <div slot="content">
                    <div>{{ $t('COMPONENT.case.base.analysis.alleleFrequencyThreshold.___info') }}</div>
                  </div>
                </borCor>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-show="display.alleleFrequencyThreshold" class="allele-frequency-threshold-block block-content col-block">
                <div :style="{ height: '15px' }"></div>
                <customForm
                  :init="analysisData"
                  :layoutType="'grid'"
                  :groupCount="6"
                  :alerts="alerts"
                  :forms="formOptions['field3_1']"
                  :scope="scope"
                  :reading="false"
                  @change="(result, validate, errors) => formOnChange('analysis', 'field3_1', result, validate, errors)"
                ></customForm>
              </div>
            </div>
          </div>
          <div class="score-threshold-container block col-block">
            <div class="block-content">
              <div class="display-icon center-block" :class="{ active: display.scoreThreshold }" @click="e => display.scoreThreshold = !display.scoreThreshold">
                <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
              </div>
              <div class="block-title-container row-block">
                <div class="block-title">{{ $t('COMPONENT.case.base.analysis.scoreThreshold.___title') }}</div>
                <borCor
                  :width="'300px'"
                  :background="'white'"
                  :border="'#CCCCCC'"
                  :radius="'0px'"
                  :blockStyle="{ padding: '10px' }"
                >
                  <div slot="trigger">
                    <img :src="require('../../assets/images/info-circle-regular.svg')" alt="" :style="{ width: '16px' }">
                  </div>
                  <div slot="content">
                    <div>{{ $t('COMPONENT.case.base.analysis.scoreThreshold.___info') }}</div>
                  </div>
                </borCor>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-show="display.scoreThreshold" class="score-threshold-block block-content col-block">
                <div :style="{ height: '15px' }"></div>
                <customForm
                  :init="analysisData"
                  :layoutType="'grid'"
                  :groupCount="6"
                  :alerts="alerts"
                  :forms="formOptions['field3_2']"
                  :scope="scope"
                  :reading="false"
                  @change="(result, validate, errors) => formOnChange('analysis', 'field3_2', result, validate, errors)"
                ></customForm>
              </div>
            </div>
          </div>
        </div>
        <template v-if="['analysis'].includes(mode)">
          <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
          <div class="analysis-block col-block width-full">
            <div class="analysis-title-container row-block">
              <div class="analysis-title-block row-block" :class="{ disabled: familyAnalysisAlert !== undefined }">
                <div v-if="familyAnalysisAlert !== undefined" class="analysis-disabled-mask container-block"></div>
                <div class="analysis-title main">{{ $t('COMPONENT.case.base.analysis.___familyTitle') }}</div>
                <div :style="{ width: '10px' }"></div>
                <switchButton
                  :checked="analysisData.family_analysis"
                  @input="c => { analysisData.family_analysis = c }"
                ></switchButton>
              </div>
              <div :style="{ width: '20px' }"></div>
              <div v-if="familyAnalysisAlert" class="analysis-alert">{{ familyAnalysisAlert }}</div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div v-show="analysisData.family_analysis" class="family-analysis-container block col-block">
              <div class="block-content">
                <div class="display-icon center-block" :class="{ active: display.familyAnalysis }" @click="e => display.familyAnalysis = !display.familyAnalysis">
                  <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
                </div>
                <div class="block-title-container row-block">
                  <div class="block-title" :style="{ 'font-weight': '500' }">{{ $t('COMPONENT.case.base.analysis.familyAnalysis.___title') }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div v-show="display.familyAnalysis" class="family-analysis-block block-content col-block width-full">
                  <div :style="{ height: '15px' }"></div>
                  <div class="family-analysis-option-container col-block flex-start">
                    <div class="family-analysis-option-block row-block">
                      <div class="family-analysis-option-title">{{ $t('COMPONENT.case.base.analysis.familyAnalysis.option.title.___excludeVariant') }}</div>
                      <switchButton
                        :checked="analysisData.family_exclude"
                        @input="c => { analysisData.family_exclude = c }"
                      ></switchButton>
                    </div>
                  </div>
                  <div :style="{ height: '10px' }"></div>
                  <div class="family-analysis-case-container col-block width-full">
                    <baseFamilyCase
                      :ref="'family-base'"
                      :mode="mode"
                      :defaultData="defaultData"
                      @change="data => familyDatas = data"
                    ></baseFamilyCase>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-if="layoutBlocks.includes('file')">
      <hr class="custom full" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <div class="file-container col-block width-full">
        <div class="file-title row-block">
          <div class="title row-block">
            <b>{{ { 'vcf': $t('COMPONENT.case.base.file.vcf.___title'), 'fastq': $t('COMPONENT.case.base.file.fastq.___title') }[dataset] }}</b>
            <div :style="{ width: '5px' }"></div>
            <div>{{ '(' + $t('COMPONENT.case.base.file.___afterAlert') + ')' }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="['supervisor'].includes(user.role) && ['fastq'].includes(dataset) && !_LOCAL_BUILD">
            <div :style="{ width: '15px' }"></div>
            <div class="file-cloud-container row-block">
              <div class="file-cloud-title">{{ $t('COMPONENT.case.base.file.___cloudTitle') }}</div>
              <div :style="{ width: '8px' }"></div>
              <switchButton
                :disabled="false"
                :checked="fromCloud"
                @input="c => { fromCloud = c; initFile(); }"
              ></switchButton>
            </div>
          </template>
          <div :style="{ flex: 1 }"></div>
          <div class="other row-block">
            <div :style="{ flex: 1 }"></div>
            <button v-if="dataset === 'fastq'" class="white-gray-button circle-button center-block" :disabled="Object.values(fileSets[fileSets.length - 1]).some(file => !file)" @click="e => fileSets.push({ r1: null, r2: null })">
              <img :src="require('../../assets/images/plus-solid.svg')" alt="">
            </button>
            <div v-else></div>
          </div>
        </div>
        <template v-if="dataset === 'vcf'">
          <div class="alert-container col-block width-full">
            <div class="alert" v-html="$t('COMPONENT.case.base.file.alert.___content')"></div>
          </div>
        </template>
        <template v-if="dataset === 'fastq'">
          <div :style="{ height: '4px' }"></div>
          <customForm
            :init="caseData"
            :layoutType="'grid'"
            :groupCount="6"
            :alerts="alerts"
            :forms="formOptions['field4']"
            :scope="scope"
            :reading="false"
            @change="(result, validate, errors) => formOnChange('case', 'field4', result, validate, errors)"
          ></customForm>
          <div :style="{ height: '15px' }"></div>
          <div class="pipeline-type-container col-block width-full">
            <div class="pipeline-type-block row-block">
              <div class="pipeline-type-form-container row-block" :class="{ disabled: (pipelineMetadataMap[result['case'].library_type_name] || {}).type }">
                <div class="pipeline-type-form-mask"></div>
                <div class="pipeline-type-form-title">{{ $t('COMPONENT.case.base.file.pipeline.title.___single') }}</div>
                <switchButton
                  :disabled="false"
                  :active="true"
                  :checked="pipelineType === 'paired'"
                  @input="c => pipelineType = c ? 'paired' : 'single'"
                ></switchButton>
                <div class="pipeline-type-form-title">{{ $t('COMPONENT.case.base.file.pipeline.title.___paired') }}</div>
              </div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </template>
        <div v-show="dataset === 'vcf'" class="file-content">
          <div :style="{ height: '15px' }"></div>
          <div class="file-set-group row-block stretch" v-for="(set, index) in vcfSets" :key="index">
            <div class="file-block col-block" :style="{ flex: 2, width: 0 }">
              <div class="title-block row-block">
                <div class="title">{{ $t('COMPONENT.case.base.file.vcf.file.___snvTitle') }}</div>
                <div class="required">*</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ height: '10px' }"></div>
              <template v-if="set.snv">
                <div class="source-container col-block flex-start width-full">
                  <div class="source-block row-block">
                    <div class="source shrink ellipsis" :title="set.snv.name">{{ set.snv.name }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div :style="{ height: '10px' }"></div>
              </template>
              <template v-if="['manager', 'supervisor'].includes(user.role) || userSetting.allow_upload_vcf || _LOCAL_BUILD">
                <div v-if="!fromCloud" class="mask">
                  <input v-show="false" type="file" :id="'set' + (index + 1) + '_snv'" extension="vcf,vcf.gz" @change="e => fileTypeCheck(e, e => selectFile(e, set, 'snv'), () => addToast('error', $t('COMMON.toast.___fileTypeAlert', { types: 'VCF' })))">
                  <label :for="'set' + (index + 1) + '_snv'"></label>
                  <button class="white-gray-button circle-button">
                    <span>{{ $t('COMMON.button.___select') }}</span>
                  </button>
                </div>
                <button v-else class="white-gray-button circle-button" @click="e => openFileCloud(set, 'snv')">
                  <span>{{ $t('COMMON.button.___select') }}</span>
                </button>
              </template>
              <button v-else class="white-gray-button circle-button" @click="e => addToast('error', $t('COMMON.toast.___noPermissionToUploadFile'))">
                <span>{{ $t('COMMON.button.___select') }}</span>
              </button>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="file-block col-block" :style="{ flex: 2, width: 0 }">
              <div class="title-block row-block">
                <div class="title">{{ $t('COMPONENT.case.base.file.vcf.file.___svTitle') }}</div>
                <borCor
                  :background="'white'"
                  :border="'#CCCCCC'"
                  :radius="'0px'"
                  :blockStyle="{ padding: '10px' }"
                >
                  <div slot="trigger">
                    <img :src="require('../../assets/images/info-circle-regular.svg')" alt="" :style="{ width: '16px' }">
                  </div>
                  <div slot="content">
                    <div>{{ $t('COMPONENT.case.base.file.vcf.file.___svInfo', { count: fileLimit['sv'] }) }}</div>
                  </div>
                </borCor>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ height: '10px' }"></div>
              <template v-if="set.sv">
                <div class="source-container col-block flex-start width-full">
                  <div class="source-block row-block" v-for="(file, findex) in set.sv" :key="findex">
                    <div class="source shrink ellipsis" :title="file.name">{{ file.name }}</div>
                    <img class="source-remove-icon" :src="require('../../assets/images/minus-remove-icon.svg')" alt="" @click="e => set.sv.splice(set.sv.indexOf(file), 1)">
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div :style="{ height: '10px' }"></div>
              </template>
              <template v-if="['manager', 'supervisor'].includes(user.role) || userSetting.allow_upload_vcf || _LOCAL_BUILD">
                <div v-if="!fromCloud" class="mask">
                  <template v-if="set.snv">
                    <input v-show="false" type="file" multiple :id="'set' + (index + 1) + '_sv'" extension="vcf,vcf.gz" @change="e => fileTypeCheck(e, e => selectFile(e, set, 'sv'), () => addToast('error', $t('COMMON.toast.___fileTypeAlert', { types: 'VCF' })))">
                    <label :for="'set' + (index + 1) + '_sv'"></label>
                  </template>
                  <button class="white-gray-button circle-button" :disabled="!set.snv">
                    <span>{{ $t('COMMON.button.___select') }}</span>
                  </button>
                </div>
                <button v-else class="white-gray-button circle-button" :disabled="!set.snv" @click="e => e.currentTarget.className.split(' ').includes('disabled') && openFileCloud(set, 'sv')">
                  <span>{{ $t('COMMON.button.___select') }}</span>
                </button>
              </template>
              <button v-else class="white-gray-button circle-button" :disabled="!set.snv" @click="e => e.currentTarget.className.split(' ').includes('disabled') && addToast('error', $t('COMMON.toast.___noPermissionToUploadFile'))">
                <span>{{ $t('COMMON.button.___select') }}</span>
              </button>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="file-block col-block" :style="{ flex: 3, width: 0 }">
              <div class="title-block row-block">
                <div class="title">{{ $t('COMPONENT.case.base.file.vcf.file.___strTitle') }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ height: '10px' }"></div>
              <template v-if="set.str">
                <div class="source-container col-block flex-start width-full">
                  <div class="source-block row-block">
                    <div class="source shrink ellipsis" :title="set.str.name">{{ set.str.name }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div :style="{ height: '10px' }"></div>
              </template>
              <template v-if="['manager', 'supervisor'].includes(user.role) || userSetting.allow_upload_vcf || _LOCAL_BUILD">
                <div v-if="!fromCloud" class="mask">
                  <template v-if="set.snv">
                    <input v-show="false" type="file" :id="'set' + (index + 1) + '_str'" extension="vcf,vcf.gz" @change="e => fileTypeCheck(e, e => selectFile(e, set, 'str'), () => addToast('error', $t('COMMON.toast.___fileTypeAlert', { types: 'VCF' })))">
                    <label :for="'set' + (index + 1) + '_str'"></label>
                  </template>
                  <button class="white-gray-button circle-button" :disabled="!set.snv">
                    <span>{{ $t('COMMON.button.___select') }}</span>
                  </button>
                </div>
                <button v-else class="white-gray-button circle-button" :disabled="!set.str" @click="e => e.currentTarget.className.split(' ').includes('disabled') && openFileCloud(set, 'str')">
                  <span>{{ $t('COMMON.button.___select') }}</span>
                </button>
              </template>
              <button v-else class="white-gray-button circle-button" :disabled="!set.str" @click="e => e.currentTarget.className.split(' ').includes('disabled') && addToast('error', $t('COMMON.toast.___noPermissionToUploadFile'))">
                <span>{{ $t('COMMON.button.___select') }}</span>
              </button>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
        <div v-show="dataset === 'fastq'" class="file-content">
          <div :style="{ height: '15px' }"></div>
          <div class="file-set-group row-block stretch" v-for="(set, index) in fileSets" :key="index">
            <div class="file-block col-block" :style="{ flex: 1, width: 0 }">
              <div class="title-block row-block">
                <div class="title">{{ $t('COMPONENT.case.base.file.fastq.file.___title', { set: index + 1, read: 'R1' }) }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ height: '10px' }"></div>
              <template v-if="set.r1">
                <div class="source-container col-block flex-start width-full">
                  <div class="source-block row-block">
                    <div class="source shrink ellipsis" :title="set.r1.name">{{ set.r1.name }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div :style="{ height: '10px' }"></div>
              </template>
              <template v-if="['manager', 'supervisor'].includes(user.role) || _LOCAL_BUILD">
                <div v-if="!fromCloud" class="mask">
                  <input v-show="false" type="file" :id="'set' + (index + 1) + '_r1'" extension="fq,fq.gz,fastq,fastq.gz" @change="e => fileTypeCheck(e, e => selectFile(e, set, 'r1'), () => addToast('error', $t('COMMON.toast.___fileTypeAlert', { types: 'FASTQ' })))">
                  <label :for="'set' + (index + 1) + '_r1'"></label>
                  <button class="white-gray-button circle-button">
                    <span>{{ $t('COMMON.button.___select') }}</span>
                  </button>
                </div>
                <button v-else class="white-gray-button circle-button" @click="e => openFileCloud(set, 'r1')">
                  <span>{{ $t('COMMON.button.___select') }}</span>
                </button>
              </template>
              <button v-else class="white-gray-button circle-button" @click="e => addToast('error', $t('COMMON.toast.___noPermissionToUploadFile'))">
                <span>{{ $t('COMMON.button.___select') }}</span>
              </button>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="file-block col-block" :class="{ disabled: pipelineType === 'single' }" :style="{ flex: 1, width: 0 }">
              <div class="disabled-mask"></div>
              <div class="title-block row-block">
                <div class="title">{{ $t('COMPONENT.case.base.file.fastq.file.___title', { set: index + 1, read: 'R2' }) }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ height: '10px' }"></div>
              <template v-if="set.r2 && pipelineType !== 'single'">
                <div class="source-container col-block flex-start width-full">
                  <div class="source-block row-block">
                    <div class="source shrink ellipsis" :title="set.r2.name">{{ set.r2.name }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div :style="{ height: '10px' }"></div>
              </template>
              <template v-if="['manager', 'supervisor'].includes(user.role) || _LOCAL_BUILD">
                <div v-if="!fromCloud" class="mask">
                  <input v-show="false" type="file" :id="'set' + (index + 1) + '_r2'" extension="fq,fq.gz,fastq,fastq.gz" @change="e => fileTypeCheck(e, e => selectFile(e, set, 'r2'), () => addToast('error', $t('COMMON.toast.___fileTypeAlert', { types: 'FASTQ' })))">
                  <label :for="'set' + (index + 1) + '_r2'"></label>
                  <button class="white-gray-button circle-button">
                    <span>{{ $t('COMMON.button.___select') }}</span>
                  </button>
                </div>
                <button v-else class="white-gray-button circle-button" @click="e => openFileCloud(set, 'r2')">
                  <span>{{ $t('COMMON.button.___select') }}</span>
                </button>
              </template>
              <button v-else class="white-gray-button circle-button" @click="e => addToast('error', $t('COMMON.toast.___noPermissionToUploadFile'))">
                <span>{{ $t('COMMON.button.___select') }}</span>
              </button>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- emit -->
    <span v-show="false">{{ onError }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  getCloudFilePaths,
  getGenePanel,
  getGenePanelCondition,
  getGenePanelConditionPathway,
  getGenePanelDivisions,
  getGenePanelHpo,
  getGenePanels,
  getGenePanelSymbol,
  getManagedUsers,
  getOmicss,
  getPhenotypePanels,
  getSearchGeneEntry,
  getSearchPhenotype,
  getUserGenePanel,
  putUserSettings
} from '../../api'
import intractableDisease from './intractableDisease.vue'
import baseFamilyCase from './baseFamilyCase.vue'
import customForm from '../../components/tool/customForm'
import switchButton from '../../components/tool/switchButton'
import borCor from '../../components/tool/newBorCor.vue'
import inputTag from '../../components/tool/inputTag'
import phenotypeTag from '../../components/tool/phenotypeTag'
import geneTag from '../../components/tool/geneTag'
import routeLoading from '../../mixins/routeLoading.vue'
import { getGeneEntriesConditionData, intractableDiseaseOptions, priceMap } from '../../constants/global/data'
import { groupBy, fileTypeCheck, dateFormat, cleanObject } from '../../constants/global/util'
import { _LOCAL_BUILD } from '../../constants/global/config'

export default {
  components: {
    intractableDisease,
    baseFamilyCase,
    customForm,
    switchButton,
    borCor,
    inputTag,
    phenotypeTag,
    geneTag
  },
  mixins: [
    routeLoading
  ],
  props: {
    mode: {
      type: String,
      required: true
    },
    isUpdate: {
      type: Boolean,
      default: () => false
    },
    layoutBlocks: {
      type: Array,
      default: () => [
        'form',
        'analysis',
        'file'
      ]
    },
    dataset: {
      type: String,
      default: () => ''
    },
    scope: {
      type: String,
      default: () => ''
    },
    defaultData: {
      type: Object,
      required: true
    },
    projects: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // form
      caseData: {},
      familyDatas: [],
      intractableDiseaseResult: {
        datas: [],
        analysisSwitch: true
      },
      analysisData: {
        report_phenovardb: true,
        family_analysis: false,
        family_exclude: true
      },
      alerts: {},
      result: {
        'case': {},
        'analysis': {},
        'view': {}
      },
      validate: {},
      error: {},
      onSubmit: false,
      // options
      users: [],
      genePanels: [],
      userGenePanel: null,
      divisions: [],
      omicss: {},
      // tag
      tagData: {
        map: {
          phenotype: {},
          gene: {}
        },
        query: {
          phenotype: '',
          gene: ''
        },
        tag: {
          phenotypes: {},
          genes: {}
        },
        curTag: {
          gene: null
        },
        searchTimer: {
          phenotype: [],
          gene: []
        }
      },
      // phenotype
      phenotypePanels: [],
      searchedPhenotypes: {
        phenotypes: [],
        genes: []
      },
      selectedPhenotypes: {
        panelPhenotypes: [],
        panelGenes: [],
        phenotypes: [],
        genes: []
      },
      // file
      fromCloud: false,
      cloudFilePaths: [],
      cloudFileCurrentPath: null,
      pipelineType: 'paired',
      vcfSets: [
        {
          snv: null,
          sv: null,
          str: null
        }
      ],
      fileSets: [
        {
          r1: null,
          r2: null
        }
      ],
      fileLimit: {
        sv: 3
      },
      // display
      display: {
        phenotypePanel: false,
        genePanel: false,
        alleleFrequencyThreshold: false,
        scoreThreshold: false,
        familyAnalysis: true
      },
      // loading
      loading: {
        addToSearch: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'modal',
      'userSetting'
    ]),
    onError () {
      let result = Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
      this.$emit('onError', result)
      return result
    },
    formGroupCount () {
      return { 'create': 6, 'edit': 4, 'analysis': 6 }[this.mode]
    },
    selectedLimit () {
      return {
        phenotypes: Object.values(this.sendData.project.phenotypes || {}).filter(x => x).reduce((s, c) => s + c.length, 0) >= 30,
        genes: (this.sendData.project.gene_panels || []).length >= 10
      }
    },
    reportDatabaseable () {
      return (
        !['analysis'].includes(this.mode) ||
        !this.result['analysis'].report_phenovardb ||
        this.projects.filter(project => this.analysisData.id === project.id ? this.result['analysis'].report_phenovardb : project.report_phenovardb).length > 1
      )
    },
    familyAnalysisAlert () {
      if (['vcf'].includes(this.dataset)) {
        // return this.$t('COMPONENT.case.base.analysis.familyAnalysis.alert.___vcf')
      } else if (!this.projects.find(project => (this.analysisData.id !== project.id) && !project.fam_analyze)) {
        return ''
      }
    },
    intractableDiseaseValueMap () {
      return intractableDiseaseOptions.reduce((map, option) => ({ ...map, [option.value]: option }), {})
    },
    userGenePanelDatas () {
      return this.userGenePanel ? Array.prototype.concat.apply([], Object.entries(this.userGenePanel.data || {}).map(kv => {
        let type = kv[0]
        let datas = kv[1]
        return ['free_typing'].includes(type) ? datas.map(data => ({ category: 'gene', name: data.symbol, data: [data] })) : datas.map(data => ({ ...data, category: type }))
      })) : null
    },
    // options
    userOptions () {
      return this.users.map(user => ({ title: [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : ''), value: user.id }))
    },
    sexOptions () {
      return [
        { title: this.$t('COMPONENT.case.base.option.sex.title.___male'), value: 'Male' },
        { title: this.$t('COMPONENT.case.base.option.sex.title.___female'), value: 'Female' },
        { title: this.$t('COMPONENT.case.base.option.sex.title.___unknown'), value: 'Unknown' }
      ]
    },
    populationOptions () {
      return [
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___AfricanAfricanAmerican'), value: 'African/African-American' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___LatinoAdmixedAmerican'), value: 'Latino/Admixed American' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___AshkenaziJewish'), value: 'Ashkenazi Jewish' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___EastAsian'), value: 'East Asian' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Koreans'), value: 'Koreans' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Japanese'), value: 'Japanese' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___OtherEastAsian'), value: 'Other East Asian' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Finnish'), value: 'Finnish' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___NonFinnishEuropean'), value: 'Non-Finnish European' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Bulgarian'), value: 'Bulgarian' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Estonian'), value: 'Estonian' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___NorthWesternEuropean'), value: 'North-Western European' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___SouthernEuropean'), value: 'Southern European' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Swedish'), value: 'Swedish' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___OthernonFinnishEuropean'), value: 'Other non-Finnish European' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___SouthAsian'), value: 'South Asian' },
        { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Other'), value: 'Other' }
      ]
    },
    omicsOptions () {
      return Object.keys(this.omicss.omics || {}).map(key => ({ title: key, value: key }))
    },
    pipelineOptions () {
      let curOmics = (this.omicss.omics || {})[this.result['case'].omics_name] || {}
      return Object.keys(curOmics.pipeline || {}).map(key => ({ title: key, value: key }))
    },
    libraryTypeOptions () {
      let curOmics = (this.omicss.omics || {})[this.result['case'].omics_name] || {}
      let curPipeline = (curOmics.pipeline || {})[this.result['case'].pipeline_name] || {}
      return (curPipeline.library_type || []).map(key => ({ title: key, value: key }))
    },
    // static
    formOptions () {
      return {
        'field0': [
          {
            title: this.$t('COMPONENT.case.base.form.case.title.___owner'),
            value: 'USER_ID',
            type: 'custom',
            grid: {
              'create': 3,
              'edit': 4
            }[this.mode],
            disabled: () => false,
            validate: 'required'
          }
        ],
        'field1': [
          {
            title: this.$t('COMPONENT.case.base.form.case.title.___caseID'),
            value: 'case_id',
            type: {
              'create': 'input',
              'edit': 'input',
              'analysis': 'text'
            }[this.mode],
            grid: 2,
            wrap: true,
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.case.placeholder.___caseID'),
            validate: {
              'create': 'required',
              'edit': 'required',
              'analysis': ''
            }[this.mode]
          },
          {
            title: this.$t('COMPONENT.case.base.form.case.title.___affected'),
            value: 'AFFECTED',
            type: {
              'create': 'custom',
              'edit': 'custom',
              'analysis': 'text'
            }[this.mode],
            grid: 1,
            wrap: true,
            style: {
              'true': { color: '#83C91E' },
              'false': { color: '#999999' }
            }[this.caseData.affected + ''],
            disabled: () => false,
            inputFormat: () => ({
              'true': this.$t('COMPONENT.case.base.form.case.format.affected.___true'),
              'false': this.$t('COMPONENT.case.base.form.case.format.affected.___false')
            }[this.caseData.affected + ''])
          },
          {
            title: this.$t('COMPONENT.case.base.form.case.title.___subjectName'),
            value: 'subject_name',
            type: {
              'create': 'input',
              'edit': 'input',
              'analysis': 'text'
            }[this.mode],
            grid: 1,
            wrap: true,
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.case.placeholder.___subjectName')
          },
          {
            title: this.$t('COMPONENT.case.base.form.case.title.___sex'),
            value: 'sex',
            type: {
              'create': 'select',
              'edit': 'select',
              'analysis': 'text'
            }[this.mode],
            grid: 1,
            wrap: true,
            options: this.sexOptions,
            style: {
              Male: { color: '#003679' },
              Female: { color: '#FA3D3D' },
              Unknown: { color: '#333333' }
            }[this.result['case'].sex],
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.case.placeholder.___sex'),
            validate: {
              'create': 'required',
              'edit': 'required',
              'analysis': ''
            }[this.mode]
          },
          {
            title: this.$t('COMPONENT.case.base.form.case.title.___birthYear'),
            value: 'birth_year',
            type: {
              'create': 'select',
              'edit': 'select',
              'analysis': 'text'
            }[this.mode],
            grid: 1,
            wrap: true,
            options: [{ title: this.$t('COMPONENT.case.base.form.case.option.birthYear.___unknown'), value: 'Unknown' }, ...(new Array((new Date()).getYear() + 1)).fill('').map((_, i) => ({ title: i + 1900, value: i + 1900 })).reverse()],
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.case.placeholder.___birthYear'),
            validate: {
              'create': 'required',
              'edit': 'required',
              'analysis': ''
            }[this.mode],
            inputFormat: value => value || 'Unknown',
            outputFormat: value => (value && value !== 'Unknown') ? value : undefined
          },
          {
            title: this.$t('COMPONENT.case.base.form.case.title.___population'),
            value: 'population',
            type: {
              'create': 'select',
              'edit': 'select',
              'analysis': 'text'
            }[this.mode],
            grid: 2,
            wrap: true,
            options: this.populationOptions,
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.case.placeholder.___population')
          },
          {
            title: this.$t('COMPONENT.case.base.form.case.title.___note'),
            value: 'note',
            type: {
              'create': 'textarea',
              'edit': 'textarea',
              'analysis': 'text'
            }[this.mode],
            grid: 4,
            row: 4,
            wrap: true,
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.case.placeholder.___note'),
            validate: 'max:900'
          }
        ],
        'field2': _LOCAL_BUILD ? [
          {
            title: this.$t('COMPONENT.case.base.form.analysis.title.___name'),
            value: 'name',
            type: 'input',
            grid: 2,
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.analysis.placeholder.___name'),
            validate: 'required'
          },
          {
            title: this.$t('COMPONENT.case.base.form.analysis.title.___note'),
            value: 'note',
            type: 'textarea',
            grid: 4,
            row: 4,
            wrap: true,
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.analysis.placeholder.___note'),
            validate: 'max:300'
          }
        ] : [
          {
            title: this.$t('COMPONENT.case.base.form.analysis.title.___name'),
            value: 'name',
            type: 'input',
            grid: 2,
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.analysis.placeholder.___name'),
            validate: 'required'
          },
          {
            title: this.$t('COMPONENT.case.base.form.analysis.title.___note'),
            value: 'note',
            type: 'textarea',
            grid: 3,
            row: 4,
            wrap: true,
            disabled: () => false,
            placeholder: () => this.$t('COMPONENT.case.base.form.analysis.placeholder.___note'),
            validate: 'max:300'
          },
          {
            title: this.$t('COMPONENT.case.base.form.analysis.title.___report'),
            value: 'REPORT_PHENOVARDB',
            type: 'custom',
            grid: 1,
            disabled: () => false
          }
        ],
        'field3_1': [
          {
            title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___ad_cutoff'),
            value: 'ad_cutoff',
            type: 'number',
            errorTitle: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.errorTitle.___ad_cutoff'),
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.placeholder.___ad_cutoff'),
            outputFormat: value => (value || 0.001) - 0,
            validate: 'min_value:0|max_value:1'
          },
          {
            title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___ar_cutoff'),
            value: 'ar_cutoff',
            type: 'number',
            errorTitle: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.errorTitle.___ar_cutoff'),
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.placeholder.___ar_cutoff'),
            outputFormat: value => (value || 0.05) - 0,
            validate: 'min_value:0|max_value:1'
          },
          {
            title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___comp_het_cutoff'),
            value: 'comp_het_cutoff',
            type: 'number',
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.placeholder.___comp_het_cutoff'),
            outputFormat: value => (value || 0.05) - 0,
            validate: 'min_value:0|max_value:1'
          },
          {
            title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___exclude_low_quality_variants'),
            value: 'exclude_low_quality_variants',
            type: 'boolean',
            grid: 2,
            inputFormat: value => ![undefined, null].includes(value) ? value : false
          },
          {
            title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___enable_clinvar_benign_filter'),
            value: 'enable_clinvar_benign_filter',
            type: 'boolean',
            grid: 2,
            inputFormat: value => ![undefined, null].includes(value) ? value : true
          },
          {}
        ],
        'field3_2': [
          {
            title: this.$t('COMPONENT.case.base.form.scoreThreshold.title.___phenotype_score_cutoff'),
            value: 'phenotype_score_cutoff',
            type: 'number',
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => this.$t('COMPONENT.case.base.form.scoreThreshold.placeholder.___phenotype_score_cutoff'),
            outputFormat: value => (value || 0.3) - 0,
            validate: 'min_value:0|max_value:1'
          },
          {
            title: this.$t('COMPONENT.case.base.form.scoreThreshold.title.___variant_score_cutoff'),
            value: 'variant_score_cutoff',
            type: 'number',
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => this.$t('COMPONENT.case.base.form.scoreThreshold.placeholder.___variant_score_cutoff'),
            outputFormat: value => (value || 0.7) - 0,
            validate: 'min_value:0.6|max_value:1'
          },
          {}
        ],
        'field4': [
          {
            title: this.$t('COMPONENT.case.base.form.pipeline.title.___omics_name'),
            errorTitle: this.$t('COMPONENT.case.base.form.pipeline.errorTitle.___omics_name'),
            value: 'omics_name',
            type: 'select',
            grid: 1,
            options: this.omicsOptions,
            placeholder: () => this.$t('COMPONENT.case.base.form.pipeline.placeholder.___omics_name'),
            validate: Object.values(this.fileSets[0]).some(file => file) ? 'required' : ''
          },
          {
            title: '　',
            errorTitle: this.$t('COMPONENT.case.base.form.pipeline.errorTitle.___pipeline_name'),
            value: 'pipeline_name',
            type: 'select',
            grid: 2,
            options: this.pipelineOptions,
            placeholder: () => this.$t('COMPONENT.case.base.form.pipeline.placeholder.___pipeline_name'),
            display: result => result.omics_name,
            validate: Object.values(this.fileSets[0]).some(file => file) ? 'required' : ''
          },
          {
            title: '　',
            errorTitle: this.$t('COMPONENT.case.base.form.pipeline.errorTitle.___library_type_name'),
            value: 'library_type_name',
            type: 'select',
            grid: 3,
            options: this.libraryTypeOptions,
            placeholder: () => this.$t('COMPONENT.case.base.form.pipeline.placeholder.___library_type_name'),
            display: result => result.pipeline_name
          }
        ]
      }
    },
    pipelineMetadataMap () {
      return {
        'Roche SBX-D Whole Genome Sequencing': {
          type: 'single'
        }
      }
    },
    // global
    priceMap () { return priceMap },
    fileTypeCheck () { return fileTypeCheck },
    locale () { return this.$i18n.locale },
    _LOCAL_BUILD () { return _LOCAL_BUILD },
    // unload alert
    sendData () {
      let caseData = {
        dataset: this.dataset
      }
      let projectData = {}
      if (this.layoutBlocks.includes('form')) {
        caseData = {
          ...caseData,
          ...this.result['case'],
          affected: this.result['case'].affected || false,
          pipelineType: this.pipelineType
        }
        delete caseData.AFFECTED
        delete caseData.USER_ID
      }
      if (this.layoutBlocks.includes('analysis')) {
        // analysis
        projectData = {
          ...projectData,
          ...this.result['analysis'],
          report_phenovardb: this.result['analysis'].report_phenovardb || false,
          fam_analyze: this.analysisData.family_analysis
        }
        delete projectData.REPORT_PHENOVARDB
        // intractable disease
        if (!_LOCAL_BUILD && (this.locale === 'ja')) {
          let selectedIntractableDiseases = this.intractableDiseaseResult.datas
          if (selectedIntractableDiseases.length) {
            let intractableDiseaseGroup = groupBy(selectedIntractableDiseases, intractableDisease => intractableDisease.type, true)
            intractableDiseaseGroup['D006-4'] && (projectData.intractable_disease_panels = intractableDiseaseGroup['D006-4'].map(intractableDisease => intractableDisease.value))
            // intractableDiseaseGroup['default'] && (projectData.designated_intractable_disease_panels = intractableDiseaseGroup['default'].map(intractableDisease => intractableDisease.value))
          }
          projectData.designated_intractable_disease_panels = [
            ...(projectData.intractable_disease_panels || []),
            ...intractableDiseaseOptions.filter(option => option.type === 'default').map(option => option.value)
          ]
          projectData.intractable_disease_tag = this.intractableDiseaseResult.analysisSwitch
        }
        // phenotype
        let selectedPhenotypes = [...this.selectedPhenotypes['panelPhenotypes'], ...this.selectedPhenotypes['phenotypes']]
        if (selectedPhenotypes.length) {
          let phenotypes = groupBy(groupBy(selectedPhenotypes, phenotype => phenotype.id).map(group => group[0]), phenotype => phenotype.type, true)
          phenotypes.hpo = phenotypes.hpo ? phenotypes.hpo.map(hpo => ({
            hpo_id: hpo.id,
            hpo_name: hpo.name,
            query: hpo.query
          })) : phenotypes.hpo
          phenotypes.disease_term = phenotypes.disease_term ? phenotypes.disease_term.map(disease => ({
            disease_id: disease.id,
            disease_name: disease.name,
            query: disease.query
          })) : phenotypes.disease_term
          projectData.phenotypes = phenotypes
        }
        // gene panel
        let selectedGenes = [...this.selectedPhenotypes['panelGenes'], ...this.selectedPhenotypes['genes']]
        if (selectedGenes.length) {
          let genePanels = []
          selectedGenes = groupBy(selectedGenes, gene => gene.name).map(group => group[0])
          genePanels = selectedGenes.map(gene => ({
            name: gene.name,
            data: gene.data,
            category: gene.category
          }))
          projectData.gene_panels = genePanels
        }
        // family
        if (projectData.fam_analyze) {
          projectData.family_segregation_algorithm = this.analysisData.family_exclude
          projectData.members = this.familyDatas
        }
      }
      caseData = {
        ...caseData,
        project: projectData
      }
      return caseData
    },
    sendFileSets () {
      let fileSets = {
        vcf: this.vcfSets.filter(set => set.snv).map(set => cleanObject(set, true)),
        fastq: this.fileSets.filter(set => this.pipelineType === 'single' || (set.r1 && set.r2))
      }[this.dataset]
      return fileSets
    }
  },
  watch: {
    'defaultData' () {
      this.init()
      setTimeout(() => this.$emit('unloadAlert', false))
    },
    'result.case.user_id' (nv, ov) {
      if (ov && ((nv || -1) > 0) && (ov !== nv)) {
        this.tagData.map['gene'] = {}
        this.tagData.map['phenotype'] = {}
        this.tagData.query['gene'] = ''
        this.tagData.query['phenotype'] = ''
        this.selectedPhenotypes['genes'] = []
        this.selectedPhenotypes['phenotypes'] = []
        this.fetchOmicss()
        this.fetchPhenotypePanels()
        this.fetchUserGenePanels()
      }
    },
    'result.case.pipeline_name' (nv) {
      this.caseData = {
        ...this.caseData,
        ...this.result['case'],
        library_type_name: ''
      }
    },
    'result.case.library_type_name' (nv) {
      if (this.pipelineMetadataMap[nv] && this.pipelineMetadataMap[nv].type) {
        this.pipelineType = this.pipelineMetadataMap[nv].type
      }
    },
    // unload alert
    'sendData' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.$emit('unloadAlert', true)
      }
    },
    'sendFileSets' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.$emit('unloadAlert', true)
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalAction',
      'setModal2Action',
      'setLoadingAction',
      'setUserSettingAction'
    ]),
    async preSetData () {
      this.init()
    },
    async fetchData () {
      if (['supervisor', 'manager'].includes(this.user.role) && ['create', 'edit'].includes(this.mode)) {
        await this.fetchManagedUsers()
      }
      if (this.layoutBlocks.includes('analysis')) {
        await this.fetchPhenotypePanels()
        await this.fetchUserGenePanels()
      }
      if (this.layoutBlocks.includes('file')) {
        await this.fetchOmicss()
        if (['supervisor'].includes(this.user.role) && !_LOCAL_BUILD) {
          await this.fetchCloudFilePaths()
        }
      }
    },
    async fetchCloudFilePaths () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getCloudFilePaths(config)
        let cloudFilePaths = response.data.data
        this.cloudFilePaths = cloudFilePaths
      } catch (error) {
        throw error
      }
    },
    async fetchManagedUsers () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getManagedUsers(config)
        let users = response.data.data
        this.users = users
        this.caseData = {
          ...this.caseData,
          user_id: this.caseData.user ? this.caseData.user.id : (this.user.id || users[0].id)
        }
        this.result['case'].user_id = this.caseData.user_id
      } catch (error) {
        throw error
      }
    },
    async fetchOmicss () {
      try {
        let config = this.$ls.get('userInfo')
        let params = {
          owner_id: this.result['case'].user_id > 0 ? this.result['case'].user_id : this.user.id
        }
        let response = await getOmicss(params, config)
        let omicss = response.data.data
        this.omicss = omicss
      } catch (error) {
        throw error
      }
    },
    async fetchPhenotypePanels () {
      try {
        let config = this.$ls.get('userInfo')
        let params = {}
        if (['manager', 'supervisor'].includes(this.user.role) && this.result['case'].user_id) {
          params.user_id = this.result['case'].user_id
        }
        let response = await getPhenotypePanels(params, config)
        let phenotypePanels = response.data.data
        this.phenotypePanels = phenotypePanels.map(panel => ({
          ...panel,
          phenotypes: [
            ...panel.hpo.map(phenotype => ({
              id: phenotype.hpo_id,
              name: phenotype.hpo_name,
              query: phenotype.hpo_id + ' ' + phenotype.hpo_name,
              panel: panel,
              type: 'hpo'
            })),
            ...panel.disease_term.map(phenotype => ({
              id: phenotype.disease_id,
              name: phenotype.disease_name,
              query: phenotype.disease_id + ' ' + phenotype.disease_name,
              panel: panel,
              type: 'disease_term'
            }))
          ]
        })).filter(panel => panel.phenotypes.length)
        this.selectedPhenotypes['panelPhenotypes'] = []
      } catch (error) {
        throw error
      }
    },
    async fetchUserGenePanels () {
      try {
        let config = this.$ls.get('userInfo')
        let params = {}
        if (['manager', 'supervisor'].includes(this.user.role) && this.result['case'].user_id) {
          params.user_id = this.result['case'].user_id
        }
        let response = await getUserGenePanel(params, config)
        let userGenePanel = response.data.data
        this.userGenePanel = userGenePanel
        this.selectedPhenotypes['panelGenes'] = []
      } catch (error) {
        throw error
      }
    },
    async fetchSubData (funcs, params = []) {
      funcs = funcs || [
        'fetchGenePanelDivisions',
        'fetchGenePanels'
      ]
      this.setLoadingAction(true)
      for (let [index, func] of Object.entries(funcs)) {
        try {
          await this[func](params[index] || params[0])
        } catch (error) {
          this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        }
      }
      this.setLoadingAction(false)
    },
    async fetchGenePanelDivisions () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getGenePanelDivisions(config)
        let divisions = response.data.data
        this.divisions = divisions
      } catch (error) {
        throw error
      }
    },
    async fetchGenePanels () {
      try {
        let config = this.$ls.get('userInfo')
        let params = {}
        let response = await getGenePanels(params, config)
        let genePanels = response.data.data
        genePanels = genePanels.map(panel => ({
          ...panel,
          count: [
            (panel.data['free_typing'] || []).filter(data => data.checked !== false).length,
            (panel.data['user_defined'] || []).filter(data => data.checked !== false).length,
            (panel.data['panel'] || []).reduce((s, panelData) => s + panelData.data.filter(data => data.checked !== false).length, 0),
            (panel.data['hpo'] || []).reduce((s, panelData) => s + panelData.data.filter(data => data.checked !== false).length, 0),
            (panel.data['condition'] || []).reduce((s, panelData) => s + panelData.filter(data => data.checked !== false).data.length, 0)
          ].reduce((s, c) => s + c, 0)
        }))
        this.genePanels = genePanels
      } catch (error) {
        throw error
      }
    },
    async afterSetData () {
      setTimeout(() => this.$emit('unloadAlert', false))
    },
    init () {
      this.caseData = {
        ...this.caseData,
        ...(this.defaultData['case'] || {}),
        affected: ![null, undefined].includes(this.defaultData['case'].affected) ? this.defaultData['case'].affected : true
      }
      this.result['case'] = {
        ...this.result['case'],
        affected: this.caseData.affected
      }
      this.analysisData = {
        ...this.analysisData,
        ...(this.defaultData['analysis'] || {})
      }
      if (this.defaultData['analysis']) {
        this.analysisData = {
          ...this.analysisData,
          family_analysis: this.defaultData['analysis'].fam_analyze === undefined ? this.analysisData.family_analysis : this.defaultData['analysis'].fam_analyze,
          family_exclude: this.defaultData['analysis'].family_segregation_algorithm === undefined ? this.analysisData.family_exclude : this.defaultData['analysis'].family_segregation_algorithm
        }
        this.intractableDiseaseResult = {
          // datas: [...(this.defaultData['analysis'].intractable_disease_panels || []), ...(this.defaultData['analysis'].designated_intractable_disease_panels || [])].filter(panel => this.intractableDiseaseValueMap[panel.name]).map(panel => this.intractableDiseaseValueMap[panel.name]),
          datas: [...(this.defaultData['analysis'].intractable_disease_panels || [])].filter(panel => this.intractableDiseaseValueMap[panel.name]).map(panel => this.intractableDiseaseValueMap[panel.name]),
          analysisSwitch: !!this.defaultData['analysis'].intractable_disease_tag
        }
      }
      this.result['analysis'] = {
        ...this.result['analysis'],
        report_phenovardb: this.analysisData.report_phenovardb
      }
      this.analysisData.name = this.analysisData.name || ('Analysis-' + dateFormat(new Date(), 'yyyyMMdd'))
      this.initPhenotype()
    },
    initPhenotype (analysisData) {
      analysisData = analysisData || this.analysisData
      let phenotypes = this.analysisData.phenotypes ? [
        ...(this.analysisData.phenotypes.hpo || []).map(hpo => ({
          id: hpo.hpo_id,
          name: hpo.hpo_name,
          query: hpo.query,
          type: 'hpo'
        })),
        ...(this.analysisData.phenotypes.disease_term || []).map(disease => ({
          id: disease.disease_id,
          name: disease.disease_name,
          query: disease.query,
          type: 'disease_term'
        }))
      ] : []
      !this.searchedPhenotypes['phenotypes'].length && (this.searchedPhenotypes['phenotypes'] = [...(phenotypes || [])])
      !this.selectedPhenotypes['phenotypes'].length && (this.selectedPhenotypes['phenotypes'] = [...(phenotypes || [])])
      let genes = analysisData.gene_panels || []
      !this.searchedPhenotypes['genes'].length && (this.searchedPhenotypes['genes'] = [...(genes || [])])
      !this.selectedPhenotypes['genes'].length && (this.selectedPhenotypes['genes'] = [...(genes || [])])
    },
    async getPhenotypes (query) {
      if (!((this.tagData.tag['phenotypes'] || { datas: [] }).datas || []).includes(query)) {
        if (this.tagData.searchTimer['phenotype']) {
          clearTimeout(this.tagData.searchTimer['phenotype'])
        }
        this.tagData.searchTimer['phenotype'] = setTimeout(async () => {
          if (!this.tagData.map['phenotype'][query] && query) {
            try {
              let config = this.$ls.get('userInfo')
              let params = {
                q: query
              }
              if (['manager', 'supervisor'].includes(this.user.role) && this.result['case'].user_id) {
                params.user_id = this.result['case'].user_id
              }
              let response = await getSearchPhenotype(params, config)
              let phenotypes = response.data.data
              this.tagData.map['phenotype'] = {
                ...this.tagData.map['phenotype'],
                [query]: {
                  info: phenotypes,
                  datas: [
                    ...(phenotypes.hpo || { data: [] }).data.map(data => ({ ...data, type: 'hpo' })),
                    ...(phenotypes.disease_term || { data: [] }).data.map(data => ({ ...data, type: 'disease_term' }))
                  ]
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
          }
          this.tagData.tag['phenotypes'] = this.tagData.map['phenotype'][query] || {}
        }, 200)
      }
    },
    async getGenes (query) {
      if ((this.tagData.curTag['gene'] || {}).name !== query) {
        this.tagData.tag['genes'] = {}
        if (this.tagData.searchTimer['gene']) {
          clearTimeout(this.tagData.searchTimer['gene'])
        }
        this.tagData.searchTimer['gene'] = setTimeout(async () => {
          if (!this.tagData.map['gene'][query] && query) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let params = {
                q: query
              }
              if (['manager', 'supervisor'].includes(this.user.role) && this.result['case'].user_id) {
                params.user_id = this.result['case'].user_id
              }
              let response = await getSearchGeneEntry(params, config)
              let genes = response.data.data
              this.tagData.map['gene'] = {
                ...this.tagData.map['gene'],
                [query]: {
                  info: genes,
                  datas: [
                    ...(genes.gene || { data: [] }).data.map(data => ({ ...data, type: 'gene' })),
                    ...(genes.panel || { data: [] }).data.map(data => ({ ...data, type: 'panel' })),
                    ...(genes.hpo || { data: [] }).data.map(data => ({ ...data, type: 'hpo' })),
                    ...getGeneEntriesConditionData(genes.condition).data.map(data => ({ ...data, type: 'condition' })),
                    ...(genes.pathway || { data: [] }).data.map(data => ({ ...data, type: 'pathway' }))
                  ]
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
            this.setLoadingAction(false)
          }
          this.tagData.tag['genes'] = this.tagData.map['gene'][query] || {}
        }, 500)
      }
    },
    async addToSearch (type, data) {
      switch (type) {
        case 'phenotype': {
          if (!(this.tagData.tag['phenotypes'].datas || []).some(tag => tag.query === this.tagData.query['phenotype'])) {
            data = this.tagData.tag['phenotypes'].datas[0].query
          }
          let ary = data.split(' ')
          let phenotypeID = ary.splice(0, 1)[0]
          let phenotypeName = ary.join(' ')
          let phenotypeType = phenotypeID.startsWith('HP:') ? 'hpo' : 'disease_term'
          let phenotype = {
            id: phenotypeID,
            name: phenotypeName,
            type: phenotypeType,
            query: phenotypeID + ' ' + phenotypeName
          }
          if (!this.searchedPhenotypes['phenotypes'].some(p => p.id === phenotype.id)) {
            this.searchedPhenotypes['phenotypes'].push(phenotype)
            if (!this.selectedLimit['phenotypes']) {
              this.selectedPhenotypes['phenotypes'].push(phenotype)
            }
          } else {
            this.addToast('error', this.$t('COMMON.toast.___addSameHPOTerm'))
          }
          this.tagData.query['phenotype'] = ''
          break
        }
        case 'gene': {
          data = data.type ? data : (this.tagData.map['gene'][this.tagData.query['gene']] || { datas: [] }).datas[0]
          if (data && !this.loading['addToSearch']) {
            this.loading['addToSearch'] = true
            switch (data.type) {
              case 'gene': {
                let symbols = await this.getGeneSymbols(data.type, data.gene_id)
                let gene = {
                  name: data.symbol,
                  category: data.type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else if (oldData.checked === false) {
                  if (!this.selectedLimit['genes']) {
                    if (!this.selectedPhenotypes['genes'].some(g => g.name === gene.name)) {
                      this.selectedPhenotypes['genes'].push(oldData)
                    }
                  }
                }
                break
              }
              case 'panel': {
                let panel = await this.getGenePanel(data.id)
                const symbolTransform = symbols => symbols.reduce((s, c) => ({ ...s, [c.gene_id]: c }), {})
                let symbols = Object.values({
                  ...symbolTransform(panel.data['free_typing'] || []),
                  ...symbolTransform(panel.data['user_defined'] || []),
                  ...symbolTransform(Array.prototype.concat.apply([], (panel.data['panel'] || []).map(panel => panel.data))),
                  ...symbolTransform(Array.prototype.concat.apply([], (panel.data['hpo'] || []).map(panel => panel.data))),
                  ...symbolTransform(Array.prototype.concat.apply([], (panel.data['condition'] || []).map(panel => panel.data)))
                }).filter(data => data.checked)
                let gene = {
                  name: panel.name,
                  category: data.type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else {
                  if (!this.selectedLimit['genes']) {
                    if (!this.selectedPhenotypes['genes'].some(g => g.name === gene.name)) {
                      this.selectedPhenotypes['genes'].push(oldData)
                    }
                  }
                }
                break
              }
              case 'hpo': {
                let symbols = await this.getGeneSymbols(data.type, data.name)
                let gene = {
                  name: data.name,
                  category: data.type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else if (oldData.checked === false) {
                  if (!this.selectedLimit['genes']) {
                    if (!this.selectedPhenotypes['genes'].some(g => g.name === gene.name)) {
                      this.selectedPhenotypes['genes'].push(oldData)
                    }
                  }
                }
                break
              }
              case 'condition': {
                let symbols = await this.getGeneSymbols(data.type, data.name)
                let gene = {
                  name: data.name,
                  category: data.type,
                  condition_type: data.condition_type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else if (oldData.checked === false) {
                  if (!this.selectedLimit['genes']) {
                    if (!this.selectedPhenotypes['genes'].some(g => g.name === gene.name)) {
                      this.selectedPhenotypes['genes'].push(oldData)
                    }
                  }
                }
                break
              }
              case 'pathway': {
                let symbols = await this.getPathwaySymbols(data.id)
                let gene = {
                  name: data.name,
                  category: data.type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else if (oldData.checked === false) {
                  if (!this.selectedLimit['genes']) {
                    if (!this.selectedPhenotypes['genes'].some(g => g.name === gene.name)) {
                      this.selectedPhenotypes['genes'].push(oldData)
                    }
                  }
                }
                break
              }
              default: {}
            }
            this.tagData.query['gene'] = ''
            this.loading['addToSearch'] = false
          }
          break
        }
        default: {}
      }
    },
    async getGeneSymbols (type, query) {
      try {
        let config = this.$ls.get('userInfo')
        let api = {
          gene: getGenePanelSymbol,
          hpo: getGenePanelHpo,
          condition: getGenePanelCondition
        }[type]
        let response = await api(query, config)
        let symbols = response.data.data
        symbols = symbols.map(symbol => ({
          ...symbol,
          checked: true,
          date: new Date()
        }))
        return symbols
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        return null
      }
    },
    async getPathwaySymbols (id) {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getGenePanelConditionPathway(id, config)
        let pathwayData = response.data.data
        let symbols = (pathwayData.data || []).map(symbol => ({
          ...symbol,
          checked: true,
          date: new Date()
        }))
        return symbols
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        return null
      }
    },
    async getGenePanel (id) {
      try {
        let config = this.$ls.get('userInfo')
        let params = {}
        if (['manager', 'supervisor'].includes(this.user.role) && this.result['case'].user_id) {
          params.user_id = this.result['case'].user_id
        }
        let response = await getGenePanel(id, params, config)
        let panel = response.data.data
        return panel
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        return null
      }
    },
    addToPanel (phenotype) {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      action({
        action: 'addToPanel',
        width: '468px',
        param: {
          phenotype: phenotype,
          panels: this.phenotypePanels
        },
        callback: async result => {
          if (result) {
            await this.fetchPhenotypePanels()
          }
        }
      })
    },
    openGenePanelDataSelect (data) {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      action({
        action: 'genePanelDataSelect',
        width: '1208px',
        param: {
          data: data
        }
      })
    },
    async openGenePanelSearch () {
      if (!(this.genePanels.length && this.divisions.length)) {
        await this.fetchSubData()
      }
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      action({
        action: 'genePanelQuickSelection',
        width: '1208px',
        customStyles: {
          'max-height': 'calc(100% - 160px)'
        },
        param: {
          datas: this.genePanels,
          divisions: this.divisions
        },
        callback: async result => {
          if (result) {
            await this.addToSearch('gene', {
              type: 'panel',
              id: result - 0
            })
          }
        }
      })
    },
    onEvent (e, c) {
      if (['input', 'tag', 'send'].includes(e)) {
        if (c) {
          let id = c.id || (this.users.find(user => c === [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')) || {}).id
          this.result['case'].user_id = id || this.result['case'].user_id
          this.caseData = {
            ...this.caseData,
            ...this.result['case'],
            user_id: this.result['case'].user_id
          }
        } else {
          this.result['case'].user_id = -1
        }
      }
    },
    initFile () {
      this.vcfSets = [
        {
          snv: null,
          sv: null,
          str: null
        }
      ]
      this.fileSets = [
        {
          r1: null,
          r2: null
        }
      ]
    },
    selectFile (e, set, target) {
      if (target === 'sv') {
        let setFiles = set[target] || []
        let setFilesNames = setFiles.map(file => file.name)
        let files = Array.from(e.target.files).filter(file => !setFilesNames.includes(file.name))
        if ((files.length + setFiles.length) <= this.fileLimit['sv']) {
          set[target] = [...setFiles, ...files]
        } else {
          this.addToast('error', this.$t('COMMON.toast.___fileUploadLimit', { count: this.fileLimit['sv'] }))
        }
      } else {
        set[target] = e.target.files[0]
      }
    },
    openFileCloud (set, target) {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      let selectedPaths = Array.prototype.concat.apply([], (!target.startsWith('r') ? this.vcfSets : this.fileSets).map(set => Object.values(set).map(file => (file || {}).path).filter(x => x)))
      selectedPaths = selectedPaths.filter(path => path !== (set[target] || {}).path)
      action({
        action: 'fileCloud',
        width: '616px',
        param: {
          type: 'single',
          options: {
            checkbox: false
          },
          fileTypes: ['fastq', 'fq', 'fastq.gz', 'fq.gz'],
          paths: this.cloudFilePaths,
          currentPath: set[target] ? set[target].path : this.cloudFileCurrentPath || this.userSetting.cloudspace_browse_path || '',
          disabledPaths: selectedPaths,
          defaultSelectedPaths: set[target] ? [set[target].path] : [],
          functions: {
            saveCurrentPath: path => this.saveCurrentPath(path)
          }
        },
        callback: async result => {
          if (result) {
            let path = result[0]
            const contentTypeMap = {
              gz: 'application/x-gzip',
              vcf: 'text/directory'
            }
            set[target] = {
              name: path.split('/').reverse()[0],
              type: contentTypeMap[path.split('.').reverse(0)[0]] || 'text/plain',
              path: path
            }
          }
        }
      })
    },
    async saveCurrentPath (path) {
      try {
        let config = this.$ls.get('userInfo')
        let folderPath = path.replace(/\/(?!.*\/).*$/, '')
        let data = {
          cloudspace_browse_path: folderPath
        }
        let response = await putUserSettings(data, config)
        let userSettings = response.data.data
        this.cloudFileCurrentPath = response.data.data.cloudspace_browse_path
        this.setUserSettingAction(userSettings)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    formOnChange (key, field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result[key] = {
        ...this.result[key],
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.caseData)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    fileValidate () {
      if ((this.pipelineType === 'paired') && (Object.values(this.fileSets[this.fileSets.length - 1]).filter(file => file).length === 1)) {
        this.addToast('error', this.$t('COMMON.toast.___dataShouldBePaired'))
        return false
      } else if ((this.vcfSets[0].sv || this.vcfSets[0].str) && !this.vcfSets[0].snv) {
        this.addToast('error', this.$t('COMMON.toast.___snvFileRequired'))
        return false
      } else {
        return true
      }
    },
    familyValidate () {
      return this.$refs['family-base'].validateSubmit()
    },
    async validateSubmit () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['file'] = !this.layoutBlocks.includes('file') || this.fileValidate()
      result['family'] = !this.sendData.project.fam_analyze || this.familyValidate()
      if (!Object.values(result).includes(false)) {
        return true
      }
      this.onSubmit = false
    },
    async submit () {
      let data = this.sendData
      let fileSets = this.sendFileSets
      return { data: data, fileSets: fileSets, users: this.users }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/base.vue